import './styles.css';

import { LoadingOutlined, PlusCircleFilled, ShopOutlined, UploadOutlined } from '@ant-design/icons';
import { OfficialStore } from '@models/OfficialStore';
import * as OfficialStoreService from '@services/officialStore';
import { FullScreenModal } from '@styles/globals';
import { Button, Col, FormInstance, Image, Input, message, notification, Row, Typography, Upload } from 'antd';
import { useState } from 'react';

import * as S from '../../styles';
import { UploadOrderCoverModal } from '../UploadOrderCoverModal';
import { UploadOrderPreviewCoverModal } from '../UploadOrderPreviewCoverModal';

const { Title } = Typography;

interface InformationsPanelProps {
  officialStore: OfficialStore;
  logoUrl: string;
  setLogoUrl: React.Dispatch<React.SetStateAction<string>>;
  form: FormInstance;
}

const InformationsPanel: React.FC<InformationsPanelProps> = ({ logoUrl, setLogoUrl, officialStore, form }) => {
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [showUploadCoverModal, setShowUploadCoverModal] = useState(false);
  const [showUploadPreviewCoverModal, setShowUploadPreviewCoverModal] = useState(false);

  function beforeUpload(file: File) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      notification.error({ message: 'Formato inválido', description: 'Apenas imagens JPG/PNG são aceitas!' });
    }

    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      notification.error({ message: 'Arquivo muito grande', description: 'A imagem deve ser menor que 10MB!' });
    }
    return isJpgOrPng && isLt2M;
  }

  const handleUpload = async ({ file }: any) => {
    if (!file) return;

    setLoadingUpload(true);
    try {
      const { data } = await OfficialStoreService.uploadImage(file);

      if (data) setLogoUrl(data.url);

      message.success('Imagem alterada com sucesso!');
    } catch {
      message.error('Erro ao alterar imagem!');
    } finally {
      setLoadingUpload(false);
    }
  };

  const getUploadContent = () => {
    if (logoUrl || officialStore.logoUrl)
      return (
        <Image
          src={logoUrl ? logoUrl : officialStore.logoUrl}
          style={{ width: '100%', maxWidth: '150px', borderRadius: '8px' }}
          preview={false}
          fallback="data:image/png;base64,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"
        />
      );

    if (loadingUpload)
      return (
        <S.LoadingContainer>
          <LoadingOutlined style={{ color: 'var(--primary-color)' }} />
        </S.LoadingContainer>
      );

    return (
      <S.UploadBody>
        <PlusCircleFilled style={{ color: 'var(--primary-color)' }} />
        <h5>Adicionar um logo</h5>
      </S.UploadBody>
    );
  };

  return (
    <Col xs={24} sm={24} lg={16} xxl={12} className="d-flex">
      <S.Panel>
        <Title level={4} style={{ color: '#555' }}>
          Informações da Loja
        </Title>

        <Row gutter={16}>
          <Col>
            <Upload showUploadList={false} beforeUpload={beforeUpload} customRequest={handleUpload}>
              {getUploadContent()}
            </Upload>
          </Col>

          <Col style={{ flexGrow: 1 }}>
            <Row>
              <S.CustomFormItem
                name="description"
                label="Nome da Loja"
                rules={[{ required: true, message: 'Informe o nome da loja!' }]}
                style={{ width: '100%' }}
              >
                <Input type="text" placeholder="Digite o nome" prefix={<ShopOutlined />} />
              </S.CustomFormItem>
            </Row>

            <Row style={{ marginTop: '1rem', flexDirection: 'column' }}>
              <Col className="cover-col">
                <Button
                  style={{ padding: '10px', height: 'auto', borderRadius: '4px' }}
                  type={form.getFieldsValue(['orderCoverUrl'])?.orderCoverUrl ? 'default' : 'primary'}
                  onClick={() => setShowUploadCoverModal(!showUploadCoverModal)}
                >
                  <UploadOutlined style={{ marginRight: '0.5rem' }} />
                  <span style={{ display: form.getFieldsValue(['orderCoverUrl'])?.orderCoverUrl ? 'none' : 'inline' }}>
                    Carregar capa do pedido
                  </span>
                  <span style={{ display: form.getFieldsValue(['orderCoverUrl'])?.orderCoverUrl ? 'inline' : 'none' }}>
                    {`capa-pedidos-${officialStore.description}`}
                  </span>
                </Button>

                <Button
                  type="text"
                  className="change-btn"
                  style={{ display: form.getFieldsValue(['orderCoverUrl'])?.orderCoverUrl ? 'inline' : 'none' }}
                  onClick={() => setShowUploadCoverModal(!showUploadCoverModal)}
                >
                  Alterar
                </Button>

                <FullScreenModal
                  destroyOnClose={true}
                  footer={null}
                  forceRender={false}
                  visible={showUploadCoverModal}
                  onOk={() => setShowUploadCoverModal(false)}
                  onCancel={() => setShowUploadCoverModal(false)}
                >
                  <UploadOrderCoverModal
                    closeModal={() => setShowUploadCoverModal(false)}
                    officialStoreName={officialStore.description}
                    form={form}
                  ></UploadOrderCoverModal>
                </FullScreenModal>
              </Col>
              <p style={{ display: 'block', color: '#6A6A6A', marginTop: '0.5rem', fontSize: '0.75rem' }}>
                A capa é a primeira página do PDF do pedido que será enviado ao representante.
              </p>
            </Row>

            <Row style={{ marginTop: '1rem', flexDirection: 'column' }}>
              <Col className="cover-col">
                <Button
                  style={{ padding: '10px', height: 'auto', borderRadius: '4px' }}
                  type={form.getFieldsValue(['orderPreviewCoverUrl'])?.orderPreviewCoverUrl ? 'default' : 'primary'}
                  onClick={() => setShowUploadPreviewCoverModal(!showUploadPreviewCoverModal)}
                >
                  <UploadOutlined style={{ marginRight: '0.5rem' }} />
                  <span
                    style={{
                      display: form.getFieldsValue(['orderPreviewCoverUrl'])?.orderPreviewCoverUrl ? 'none' : 'inline',
                    }}
                  >
                    Carregar capa do orçamento
                  </span>
                  <span
                    style={{
                      display: form.getFieldsValue(['orderPreviewCoverUrl'])?.orderPreviewCoverUrl ? 'inline' : 'none',
                    }}
                  >
                    {`capa-previa-orçamentos-${officialStore.description}`}
                  </span>
                </Button>

                <Button
                  type="text"
                  className="change-btn"
                  style={{
                    display: form.getFieldsValue(['orderPreviewCoverUrl'])?.orderPreviewCoverUrl ? 'inline' : 'none',
                  }}
                  onClick={() => setShowUploadPreviewCoverModal(!showUploadCoverModal)}
                >
                  Alterar
                </Button>

                <FullScreenModal
                  destroyOnClose={true}
                  footer={null}
                  forceRender={false}
                  visible={showUploadPreviewCoverModal}
                  onOk={() => setShowUploadPreviewCoverModal(false)}
                  onCancel={() => setShowUploadPreviewCoverModal(false)}
                >
                  <UploadOrderPreviewCoverModal
                    closeModal={() => setShowUploadPreviewCoverModal(false)}
                    officialStoreName={officialStore.description}
                    form={form}
                  ></UploadOrderPreviewCoverModal>
                </FullScreenModal>
              </Col>
              <p style={{ display: 'block', color: '#6A6A6A', marginTop: '0.5rem', fontSize: '0.75rem' }}>
                A capa é a primeira página do PDF do orçamento que será enviado ao representante.
              </p>
            </Row>
          </Col>
        </Row>
      </S.Panel>
    </Col>
  );
};

export default InformationsPanel;
